<script setup lang="ts">
const { workspace } = useAuth()
const { data: config } = useQueryConfig.current()
</script>

<template>
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-white/90 p-3"
  >
    <div class="max-w-lg text-center">
      <h2 class="mb-6 text-2xl font-bold">
        {{ $t('paused.title') }}
      </h2>
      <i18n-t
        keypath="paused.message"
        tag="p"
        class="mb-4"
      >
        <template #workspace>
          <strong>{{ workspace?.attributes.displayName }}</strong>
        </template>
        <template #contact>
          <DTButton
            dense
            variant="link"
            :to="`mailto:${config?.support_email}`"
          >
            {{ config?.support_email }}
          </DTButton>
        </template>
      </i18n-t>
      <DTButton
        to="/2/logout"
        size="sm"
        variant="default"
      >
        {{ $t('logout') }}
      </DTButton>
    </div>
  </div>
</template>
